import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=2ec413bd&scoped=true"
import script from "./PersonnelList.vue?vue&type=script&lang=ts"
export * from "./PersonnelList.vue?vue&type=script&lang=ts"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&id=2ec413bd&prod&lang=css"
import style1 from "./PersonnelList.vue?vue&type=style&index=1&id=2ec413bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec413bd",
  null
  
)

export default component.exports